window.addEventListener('load', function() {
  var hero = document.querySelector('.hero-video-wrapper .hero-content');
  if(hero) {
    hero.style.position = 'absolute';
    hero.style.top = '50%';
    hero.style.left = '0';
    hero.style.transform = 'translateY(-50%)';
    hero.style.maxWidth = '100%';
    hero.style.textAlign = 'left';
    hero.style.paddingLeft = '0';
    hero.style.marginLeft = '0';
    hero.style.zIndex = '10';
  }
});